import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Col extends Component {
  static propTypes = {
    gutters: PropTypes.bool,
    right: PropTypes.bool,
    flex: PropTypes.bool,
    margin: PropTypes.number,
    maxHeight: PropTypes.number,
    children: PropTypes.any
  }

  render() {
    const { children, gutters, margin, flex, right, maxHeight } = this.props
    const textAlign = right ? 'right' : 'left'

    return (
      <div
        style={{
          flex: flex && flex,
          textAlign,
          maxHeight: maxHeight || '100%',
          margin: gutters ? `0 ${margin}px` : 0,
          width: '100%'
        }}
      >
        {children}
      </div>
    )
  }
}
